module.exports = __webpack_public_path__ + "static/media/bg1.0b5aebb4.png";